import { useState } from "react";
import equityIndexIcon from "../../../assets/storymap/indices/demographics.svg";
import livabilityIndexIcon from "../../../assets/storymap/indices/livability.svg";
import economyIndexIcon from "../../../assets/storymap/indices/economy.svg";
import accessibilityIndexIcon from "../../../assets/storymap/indices/accessibility.svg";
import environmentIndexIcon from "../../../assets/storymap/indices/environment.svg";
import { toggleDashboardTab, toggleOverlayLayer } from "../../../utils/messages";

const indexItems = [
  {
    key: "equity",
    label: "Equity",
    icon: equityIndexIcon,
    value: "Low to Very Low",
    pillBg: "bg-port-blue",
    insideTextColor: "text-white",
    outsideTextColor: "text-port-blue",
    id: 347,
    tab: "Demographics"
  },
  {
    key: "economy",
    label: "Economy",
    icon: economyIndexIcon,
    value: "Low to Very Low",
    pillBg: "bg-port-blue",
    insideTextColor: "text-white",
    outsideTextColor: "text-port-blue",
    id: 351,
    tab: "Economy",
  },
  {
    key: "Livability",
    label: "Livability",
    icon: livabilityIndexIcon,
    value: "Low to Very Low",
    pillBg: "bg-port-blue",
    insideTextColor: "text-white",
    outsideTextColor: "text-port-blue",
    id: 345,
    tab: "Livability",
  },
  {
    key: "accessibility",
    label: "Accessibility",
    icon: accessibilityIndexIcon,
    value: "Moderate to Low",
    pillBg: "bg-port-blue",
    insideTextColor: "text-white",
    outsideTextColor: "text-port-blue",
    id: 350,
    tab: "Accessibility",
  },
  {
    key: "environment",
    label: "Environment",
    icon: environmentIndexIcon,
    value: "Moderate",
    pillBg: "bg-port-blue",
    insideTextColor: "text-white",
    outsideTextColor: "text-port-blue",
    id: 353,
    tab: "Environment",
  },
];

function IndexList() {
  const [activeKey, setActiveKey] = useState("equity");

  return (
    <div className="mt-4 w-full pl-8">
      <ul className="space-y-4">
        {indexItems.map((item) => {
          const isActive = activeKey === item.key;

          return (
            <li key={item.key}>
              <button
                type="button"
                className="flex w-full items-center gap-4 text-left focus:outline-none"
                onMouseEnter={() => setActiveKey(item.key)}
                onMouseLeave={() => setActiveKey("")}
                onFocus={() => setActiveKey(item.key)}
                onBlur={() => setActiveKey("")}
                onClick={() => {
                  setActiveKey(item.key);
                  toggleOverlayLayer(item.id, `${item.label} Index`);
                  toggleDashboardTab(item.tab);
                }}
                aria-expanded={isActive}
              >
                {/* PILL (always shown, expands on active) */}
                <span
                  className={[
                    "relative flex items-center overflow-hidden h-12 w-14 rounded-l-xl rounded-r-full shadow-lg",
                    item.pillBg,
                    isActive ? "w-full mr-8" : "w-16",
                  ].join(" ")}
                >
                  {/* Icon slot */}
                  <span className="flex flex-shrink-0 w-16 items-center justify-center">
                    <img src={item.icon} alt="" className="h-10 w-10" />
                  </span>

                  {/* Inside label + value (only when active) */}
                  <span
                    className={[
                      "flex min-w-0 flex-1 items-center justify-between gap-4 pr-6 ml-4",
                      "transition-opacity duration-200",
                      isActive ? "opacity-100" : "opacity-0",
                    ].join(" ")}
                  >
                    <span
                      className={[
                        "min-w-0 truncate text-xl font-extrabold tracking-wide",
                        item.insideTextColor,
                      ].join(" ")}
                    >
                      {item.label}
                    </span>

                    <span
                      className={[
                        "whitespace-nowrap text-xl font-extrabold",
                        item.insideTextColor,
                      ].join(" ")}
                    >
                      {item.value}
                    </span>
                  </span>
                </span>

                {/* Outside label (only when NOT active) */}
                {!isActive &&
                  <span
                    className={[
                      "text-xl font-extrabold tracking-wide transition-opacity duration-150",
                      item.outsideTextColor,
                    ].join(" ")}
                  >
                    {item.label}
                  </span>
                }
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default IndexList;